
<div qmap-validator #validator="qmap-validator">
    
    <div qmap-question [qMap]="curQ" *ngFor="let curQ of transform['qMap']" [model]="model">
        <qmap-template qMap_type="shorttext" mode="inner_layout">
            <ng-template let-self="self" let-parent="parent">
                <label>{{ ( parent.qMap.title || parent.qMap.id )| qmap_el: parent }} </label>
                <input #power="ngModel" matInput [maxlength]="parent.qMap.maxlength || 1000000"
                    [name]="parent.qMap.id" [type]="parent.qMap.style|| 'text'" [(ngModel)]="self.localVal"
                    (blur)="self.applyValue(self.localVal)" [required]="parent.qMap.required"
                    [disabled]="parent.qMap.disabled" pattern="{{ parent.qMap.regex }}"/>
                    
                <span *ngIf="parent.qMap.required && !self.localVal">{{ 'GENERIC.FIELD_REQUIRED' | translate}}</span>
                <i *ngIf="parent.qMap.required" matSuffix>*</i>
    
                <span *ngIf="parent.qMap.subtitle">{{ parent.qMap.subtitle | qmap_el: parent }} </span>
            </ng-template>
        </qmap-template>

        <qmap-template qMap_type="number" mode="inner_layout">
            <ng-template let-self="self" let-parent="parent">
                <label>{{ ( parent.qMap.title || parent.qMap.id )| qmap_el: parent }} </label>
            
                <input #power="ngModel" matInput [maxlength]="parent.qMap.maxlength || 1000000"
                    [name]="parent.qMap.id" [type]="parent.qMap.style|| 'text'" [(ngModel)]="self.localVal"
                    (blur)="self.applyValue(self.localVal)" [required]="parent.qMap.required"
                    [disabled]="parent.qMap.disabled" pattern="{{ parent.qMap.regex }}"/>
                
                <span *ngIf="parent.qMap.required && !self.localVal">{{ 'GENERIC.FIELD_REQUIRED' | translate }}</span>
                <i *ngIf="parent.qMap.required" matSuffix>*</i>
                <span *ngIf="parent.qMap.subtitle">{{ parent.qMap.subtitle | qmap_el: parent }} </span>
            </ng-template>
        </qmap-template>
    </div>


    <button [disabled]="!validator?.valid" (click)="onSave()">
        <span translate class="label">GENERIC.SAVE</span>
    </button>
    <button (click)="onCancel()">
        <span translate class="label">GENERIC.CANCEL</span>
    </button>
</div>